'use strict';
import './form';
import {initForms} from "./contactForms";

const $ = require('jquery');

$(() => {
    initForms();
    $('#regForm').parsley();
    $('#regSubmit').hide();
});

window.captchaSuccess = function() {
    $('.g-recaptcha').hide();
    $('#regSubmit').show();
};

window.captchaExpired = function() {
    $('.g-recaptcha').show();
    $('#regSubmit').hide();
};
